<template>
  <div class="flex flex-row" style="position: fixed;z-index:1; width: 880px;">
    <app-table v-bind="$attrs" class="table-auto" style="width:840px">
      <template v-slot:table-body>
        <tr
          class="border border-collapse border-dashed border-blue border-t-0 border-l-0 border-r-0 h-12"
          :class="header.attr === 'officeMessage' ? 'border-none' : ''"
          :style="
            header.attr == 'officeMessage' && currentUser.role_id == 1
              ? 'display:none;'
              : ''
          "
          v-for="(header, index) in headers"
          :key="index"
        >
          <td
            class="mt-2 items-center justify-center"
            style="width:30px; position: relative; top:3px;"
            v-if="currentPoliticalAction.application.option.viewType == 4"
          >
            <approved-icn width="20" height="20" />
          </td>
          <td
            class="mt-2 items-center justify-center"
            style="width:30px; position: relative; top:3px;"
            v-else-if="currentPoliticalAction.application.option.viewType === 1"
          >
            <approved-icn class="status-blue" width="20" height="20" />
          </td>
          <td
            class="mt-2 items-center justify-center"
            style="width:30px; position: relative;"
            v-else
          >
            <rejected-icn
              v-if="
                ((currentPoliticalAction.memory.option.viewType === 7 ||
                  currentPoliticalAction.memory.option.viewType === 3) &&
                  sentBackTitle().includes(
                    header.attr
                      .split(/(?=[A-Z])/)
                      .join('_')
                      .toLowerCase(),
                  )) ||
                  header.comment
              "
              class="mb-1"
              width="20"
              height="20"
            />
            <wait-yellow-icn v-else width="20" height="20" />
          </td>
          <td width="150px" style="min-width: 150px;">
            <span class="text-lg text-blue font-bold">{{ header.title }}</span>
            <LetterGreen
              v-if="header.attr == 'officeMessage'"
              class="pt-1 ml-1 mb-2 blue-icon"
              style="display: inline-block;"
              width="18px"
              height="18px"
            ></LetterGreen>
          </td>

          <td v-if="header.attr == 'period'" style="max-width:665px">
            <span>
              <AppPreviewSentBackItem
                color="blue"
                :message="
                  getSentBackItemMessage(
                    header.attr
                      .split(/(?=[A-Z])/)
                      .join('_')
                      .toLowerCase(),
                  )
                "
              />
              <div v-if="header.comment" class="flex flex-row items-center">
                <rejected-icn
                  class="mt-1.5 mr-1"
                  style="display: inline-block;"
                  width="16"
                  height="16"
                />
                <span
                  class="text-lg mt-1"
                  style="width: 590px; white-space: normal; align-items: center; word-wrap: break-word;"
                >
                  {{ header.comment }}<br />
                </span>
              </div>
              <span class="text-lg" style="word-wrap: break-word;">
                {{ $filters.dateFormat(currentPoliticalAction['startDate']) }}
                〜
                {{ $filters.dateFormat(currentPoliticalAction['endDate']) }}｜
                {{ $filters.wareki(currentPoliticalAction['startDate']) }}
                ～ {{ $filters.wareki(currentPoliticalAction['endDate']) }}
              </span>
            </span>
          </td>
          <td v-else-if="header.attr == 'memberName'" style="max-width:665px">
            <AppPreviewSentBackItem
              color="blue"
              :message="
                getSentBackItemMessage(
                  header.attr
                    .split(/(?=[A-Z])/)
                    .join('_')
                    .toLowerCase(),
                )
              "
            />
            <div v-if="header.comment" class="flex flex-row items-center">
              <rejected-icn
                class="mt-1.5 mr-1"
                style="display: inline-block;"
                width="16"
                height="16"
              />
              <span
                class="text-lg mt-1"
                style="width: 590px; white-space: normal; align-items: center; word-wrap: break-word;"
              >
                {{ header.comment }}<br />
              </span>
            </div>
            <span class="text-lg" style="word-wrap: break-word;">
              {{ currentPoliticalAction['memberName'] }}
            </span>
          </td>
          <td v-else-if="header.attr == 'actionTypes'" style="max-width:665px">
            <AppPreviewSentBackItem
              color="blue"
              :message="
                getSentBackItemMessage(
                  header.attr
                    .split(/(?=[A-Z])/)
                    .join('_')
                    .toLowerCase(),
                )
              "
            />
            <div v-if="header.comment" class="flex flex-row items-center">
              <rejected-icn
                class="mt-1.5 mr-1"
                style="display: inline-block;"
                width="16"
                height="16"
              />
              <span
                class="text-lg mt-1"
                style="width: 590px; white-space: normal; align-items: center; word-wrap: break-word;"
              >
                {{ header.comment }}<br />
              </span>
            </div>
            <span class="text-lg" style="word-wrap: break-word;">
              {{
                actionTypeNames(currentPoliticalAction['selectedActionTypes'])
              }}
            </span>
          </td>
          <td
            v-else-if="header.attr == 'submissionDate'"
            style="max-width:665px"
          >
            <AppPreviewSentBackItem
              color="blue"
              :message="
                getSentBackItemMessage(
                  header.attr
                    .split(/(?=[A-Z])/)
                    .join('_')
                    .toLowerCase(),
                )
              "
            />
            <div v-if="header.comment" class="flex flex-row items-center">
              <rejected-icn
                class="mt-1.5 mr-1"
                style="display: inline-block;"
                width="16"
                height="16"
              />
              <span
                class="text-lg mt-1"
                style="width: 590px; white-space: normal; align-items: center; word-wrap: break-word;"
              >
                {{ header.comment }}<br />
              </span>
            </div>
            <span class="text-lg" style="word-wrap: break-word;">
              {{
                $filters.dateFormat(currentPoliticalAction['submissionDate'])
              }}
            </span>
          </td>
          <td v-else-if="header.attr == 'remarks'" style="max-width:665px">
            <AppPreviewSentBackItem
              color="blue"
              :message="
                getSentBackItemMessage(
                  header.attr
                    .split(/(?=[A-Z])/)
                    .join('_')
                    .toLowerCase(),
                )
              "
            />
            <div v-if="header.comment" class="flex flex-row items-center">
              <rejected-icn
                class="mt-1.5 mr-1"
                style="display: inline-block;"
                width="16"
                height="16"
              />
              <span
                class="text-lg mt-1"
                style="width: 590px; white-space: normal; align-items: center; word-wrap: break-word;"
              >
                {{ header.comment }}<br />
              </span>
            </div>
            <span class="text-lg" style="word-wrap: break-word;">
              {{ currentPoliticalAction.application['remarks'] }}
            </span>
          </td>
          <td
            v-else-if="
              header.attr == 'officeMessage' &&
                !header.comment &&
                currentUser.role_id !== 1
            "
            style="max-width:665px"
          >
            <span>
              <AppPreviewSentBackItem
                color="blue"
                :message="getSentBackItemMessage('office_message')"
              />
              <span class="text-blue text-lg">
                新規メッセージを入力していません
              </span>
            </span>
          </td>
          <td
            v-else-if="
              header.attr == 'officeMessage' &&
                header.comment &&
                currentUser.role_id !== 1
            "
            style="max-width:665px"
          >
            <span>
              <AppPreviewSentBackItem
                color="blue"
                :message="getSentBackItemMessage('office_message')"
              />
              <div class="flex flex-row items-center">
                <rejected-icn
                  class="mt-1.5"
                  style="display: inline-block; align-self: baseline;"
                  width="16"
                  height="16"
                />
                <span
                  class="text-lg"
                  style="width: 590px; white-space: normal;"
                >
                  {{ header.comment }}<br />
                </span>
              </div>
            </span>
          </td>
          <td v-else style="max-width:665px">
            <AppPreviewSentBackItem
              color="blue"
              :message="
                getSentBackItemMessage(
                  header.attr
                    .split(/(?=[A-Z])/)
                    .join('_')
                    .toLowerCase(),
                )
              "
            />
            <div v-if="header.comment" class="flex flex-row items-center">
              <rejected-icn
                class="mt-1.5 mr-1"
                style="display: inline-block;"
                width="16"
                height="16"
              />
              <span
                class="text-lg mt-1"
                style="width: 590px; white-space: normal; align-items: center; word-wrap: break-word;"
              >
                {{ header.comment }}<br />
              </span>
            </div>

            <span class="text-lg" style="word-wrap: break-word;">{{
              currentPoliticalAction[header.attr]
            }}</span>
          </td>
        </tr>
      </template>
    </app-table>
  </div>
</template>
<script>
import { reactive, onMounted } from 'vue'
import AppTable from '@/components/ui/AppTable'
import RejectedIcn from '@/assets/icons/rejected.svg?inline'
import AppPreviewSentBackItem from '@/components/ui/AppPreviewSentBackItem'
import ApprovedIcn from '@/assets/icons/approved.svg?inline'
import WaitYellowIcn from '@/assets/icons/wait-yellow.svg?inline'
import LetterGreen from '@/assets/icons/letter-green.svg?inline'
import { useRequestReject } from '@/services/politicalActionToda/useRequestReject'
import { usePoliticalActions } from '@/services/politicalActionToda/usePoliticalActions'
import { useRequestForm } from '@/services/politicalActionToda/useRequestForm'
import { useStatus } from '@/services/politicalActionToda/useStatus'
import { useImgUploader } from '@/services/useImgUploader'
import { useDialog } from '@/services/useDialog'
import { useCurrentUser } from '@/services/useCurrentUser'

export default {
  name: 'RequestPreview_TODA',

  components: {
    AppTable,
    RejectedIcn,
    ApprovedIcn,
    WaitYellowIcn,
    LetterGreen,
    AppPreviewSentBackItem,
  },

  setup() {
    const { getIcon } = useStatus()
    const { imgUploader } = useImgUploader()
    const { rejectHeaders, rejectedAttrs } = useRequestReject()
    // const { userState } = useCurrentUser()

    const headers = reactive([
      { title: '報告日', attr: 'submissionDate', comment: '' },
      { title: '政務活動項目', attr: 'actionTypes', comment: '' },
      { title: '開始 〜 終了日', attr: 'period', comment: '' },
      { title: '参加者氏名', attr: 'memberName', comment: '' },
      { title: '場所', attr: 'place', comment: '' },
      { title: '目的', attr: 'purpose', comment: '' },
      { title: '宿泊場所', attr: 'remarks', comment: '' },
      { title: 'メッセージ', attr: 'officeMessage', comment: '' },
    ])

    onMounted(() => {
      let images = []

      if (
        currentPoliticalAction.application.images.length == 1 &&
        currentPoliticalAction.application.images[0].normalImage == null
      ) {
        images = []
      } else {
        for (
          let i = 0;
          i < currentPoliticalAction.application.images.length;
          i++
        ) {
          currentPoliticalAction.application.images[i].blackImage != null
            ? images.push(
                currentPoliticalAction.application.images[i].blackImage,
              )
            : images.push(
                currentPoliticalAction.application.images[i].normalImage,
              )
        }
      }

      imgUploader.error = ''
      imgUploader.files = []
      imgUploader.dropped = 0
      imgUploader.imgs = images

      if (rejectedAttrs.length > 0) {
        rejectedAttrs.forEach(item => {
          headers.forEach(header => {
            if (item.target === header.attr) {
              header.comment = item.comment
            }
          })
        })
      }
    })

    const { currentPoliticalAction, actionTypeNames } = usePoliticalActions()

    /**
     * 政務活動配列を表示用文字列に変換する
     *
     * @param {array} actionTypes 政務活動項目配列
     * @returns string
     */
    const replaceActionTypeToText = actionTypes => {
      let actionTypeName = []
      // 申請前プレビュー画面(入力画面から移行した場合)
      if (actionTypes.length > 0 && actionTypes[0]?.name != null) {
        actionTypes.forEach(item => {
          actionTypeName.push(item.name)
        })
        actionTypes = actionTypeName
        return actionTypes.map(actionType => actionType).join(' , ')
      }
      // 申請後プレビュー画面
      if (actionTypes.length > 0 && actionTypes[0]?.name == null) {
        return actionTypes.map(actionType => actionType).join(' , ')
      }
    }
    const sentBackTitle = () => {
      if (currentPoliticalAction.application.sentBackItems.length > 0) {
        const sentBackTitles = []
        currentPoliticalAction.application.sentBackItems[0].items.forEach(
          sentBackItem => {
            sentBackTitles.push(sentBackItem.target)
          },
        )
        return sentBackTitles
      } else {
        return ''
      }
    }

    return {
      headers,
      currentPoliticalAction,
      getIcon,
      imgUploader,
      actionTypeNames,
      rejectHeaders,
      rejectedAttrs,
      replaceActionTypeToText,
      sentBackTitle,
      ...useRequestForm(),
      ...useDialog(),
      ...useCurrentUser(),
    }
  },
}
</script>
<style lang="scss"></style>
